import React from 'react';
import PropTypes from 'prop-types';

import { constants } from '../../config';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  productId: PropTypes.string.isRequired,
  specificId: PropTypes.number,
};

const defaultProps = {
  className: '',
  specificId: null,
};

const IntranetLink = (props) => {
  let intranetLink = constants.externalIntranetLink;
  if (props.specificId) {
    intranetLink += `${constants.specificIntranetPath}${props.specificId}`;
  } else {
    intranetLink += `${constants.normalIntranetPath}${props.productId}`;
  }
  return (
    <a
      className={props.className}
      href={intranetLink}
      target="_blank"
      rel="noreferrer noopener"
    >
      {props.children}
    </a>
  );
};

IntranetLink.propTypes = IPropTypes;
IntranetLink.defaultProps = defaultProps;

export { IntranetLink };



// WEBPACK FOOTER //
// ./src/common/intranet-link/IntranetLink.jsx